/**
 * "Let's Reroll" — friendly in-page anchors for Online Store 2.0 sections.
 *
 * THE PROBLEM
 * Shopify renders a JSON-template section as
 *   <section id="shopify-section-template--21373832954013__how_it_works">
 * The `template--<id>` prefix is generated per theme, so the only way to link to a section from a
 * theme setting is to paste that full id — and DUPLICATING THE THEME REGENERATES IT, silently
 * breaking every such link. Making a backup copy of the theme is exactly when you'd least notice.
 *
 * THE FIX
 * Author anchors with the section KEY from templates/*.json instead — the hero's second CTA uses
 * `#how-it-works` for the section keyed `how_it_works`. That key is part of the template file and
 * survives duplication. On load, any `#fragment` that doesn't resolve is retried as a suffix match
 * against `[id$="__<fragment_with_underscores>"]`, and the href is rewritten to the real id.
 *
 * Anchors that already resolve are left completely alone, so this can only ever fix a dead link —
 * it can't break a working one.
 *
 * Pairs with component-anchor-links.css, which supplies the scroll-margin-top that keeps the
 * sticky header from covering the target heading.
 */
(function () {
  'use strict';

  function resolveAnchors() {
    var links = document.querySelectorAll('a[href^="#"]');

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var raw = link.getAttribute('href') || '';
      var fragment = raw.slice(1);

      /* "#" on its own, and "#0"-style dead links, are not section anchors. */
      if (!fragment) continue;

      /* Already points at something real — nothing to do. */
      try {
        if (document.getElementById(fragment)) continue;
      } catch (e) {
        continue;
      }

      /*
       * Section keys use underscores; anchors are conventionally written with hyphens.
       * Restrict to [a-z0-9_] AFTER converting so the value can't carry quotes or brackets into
       * the attribute selector below.
       */
      var key = fragment.toLowerCase().replace(/-/g, '_');
      if (!/^[a-z0-9_]+$/.test(key)) continue;

      var target = document.querySelector('[id$="__' + key + '"]');
      if (target && target.id) {
        link.setAttribute('href', '#' + target.id);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resolveAnchors);
  } else {
    resolveAnchors();
  }
})();
